var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
var variantMap = {
    blue: {
        backgroundColor: theme.blue.main,
    },
    green: {
        backgroundColor: theme.green.main,
    },
    greyLight: {
        backgroundColor: theme.transparentGrey.main,
    },
    greyMedium: {
        backgroundColor: theme.grey.darker,
    },
    navy: {
        backgroundColor: theme.navy.main,
    },
    orange: {
        backgroundColor: theme.orange.main,
    },
    orangeLight: {
        backgroundColor: theme.orange.lighter,
    },
    pink: {
        backgroundColor: theme.pink.main,
    },
    purple: {
        backgroundColor: theme.purple.main,
    },
    purpleLight: {
        backgroundColor: theme.purple.lighter,
    },
    red: {
        backgroundColor: theme.red.main,
    },
    transparentGrey: {
        backgroundColor: theme.transparentGrey.main,
    },
    white: {
        backgroundColor: theme.white.main,
    },
    yellow: {
        backgroundColor: theme.yellow.main,
    },
};
var cardStaticStyle = css({
    '&:where(a, button)': {
        cursor: 'pointer',
        userSelect: 'none',
    },
    backgroundColor: theme.background.contrast,
    borderColor: theme.border.main,
    borderRadius: tokens.borderRadius.medium,
    borderStyle: 'solid',
    borderWidth: tokens.borderWidth.thin,
    display: 'block',
    outline: 0,
    padding: tokens.spacing.medium,
    position: 'relative',
    textDecoration: 'none',
    transition: 'box-shadow 600ms cubic-bezier(0.1, 0.8, 0.2, 1), transform 600ms cubic-bezier(0.1, 0.8, 0.2, 1)',
});
export function cardStyle(_a) {
    var disableHoverEffect = _a.disableHoverEffect, hasHeadstone = _a.hasHeadstone, inverted = _a.inverted, isFocusVisible = _a.isFocusVisible;
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read((inverted ? [darkThemeStyle] : [])), false), [
        cardStaticStyle
    ], false), __read((hasHeadstone ? [css({ paddingTop: '28px' })] : [])), false), [
        isFocusVisible
            ? css({
                boxShadow: "0 0 0 2px ".concat(theme.border.focusOutline),
            })
            : css(__assign({}, (!disableHoverEffect && {
                '&:focus-within': {
                    boxShadow: theme.boxShadow.thick,
                    transform: 'translateY(-1px)',
                },
            })))
    ], false), __read((!disableHoverEffect
        ? [
            css({
                '&:hover': __assign({ boxShadow: theme.boxShadow.thick, transform: 'translateY(-1px)' }, (isFocusVisible &&
                    css({
                        boxShadow: "0 0 0 2px ".concat(theme.border.focusOutline, ", ").concat(theme.boxShadow.thick),
                    }))),
            }),
        ]
        : [])), false);
}
export var headstoneStaticStyle = css({
    display: 'flex',
    gap: tokens.spacing.small,
    left: tokens.spacing.medium,
    position: 'absolute',
    top: '-20px',
    zIndex: tokens.zIndex.default,
});
var decorStaticStyle = css({
    bottom: '-1px',
    position: 'absolute',
    top: '-1px',
    width: '4px',
    zIndex: tokens.zIndex.default,
});
export function decorStyle(_a) {
    var highlightPlacement = _a.highlightPlacement, highlightVariant = _a.highlightVariant;
    return [
        decorStaticStyle,
        css({
            backgroundColor: variantMap[highlightVariant].backgroundColor,
        }),
        highlightPlacement === 'left'
            ? css({
                borderBottomLeftRadius: tokens.borderRadius.medium,
                borderTopLeftRadius: tokens.borderRadius.medium,
                left: '-1px',
            })
            : css({
                borderBottomRightRadius: tokens.borderRadius.medium,
                borderTopRightRadius: tokens.borderRadius.medium,
                right: '-1px',
            }),
    ];
}
export var bodyStaticStyle = css({
    color: theme.text.main,
    display: 'block',
    marginBottom: tokens.spacing.small,
});
export var footerStaticStyle = css({
    alignItems: 'start',
    display: 'flex',
    flexShrink: 0,
    flexWrap: 'wrap',
    gap: tokens.spacing.small,
});
